import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';


const headerData = [
  { id: 'brand', label: 'MARCA', sort: true },
  { id: 'model', label: 'MODELO', sort: true },
  { id: 'quantity', label: 'QTD', sort: true },
  { id: 'formalizationdate', label: 'DATA FORMALIZAÇÃO', sort: true },
  { id: 'lotlppt', label: 'LOTE LPPT', sort: true },
  { id: 'saleschannels', label: 'CANAIS VENDA', sort: false },
  { id: 'icon', label: null, sort: false }
];

const styles = theme => ({
  tblHeadT: {
    color: '#ffffff',
    fontSize: '14px'
  },
  tblBorder: {
    border: '2px solid #ffffff'
  },
  headerHeight: {
    height: '40px'
  },
  textCenter: {
    textAlign: 'center'
  },
  cellPadding: {
    paddingLeft: '16px'
  },
  tblSort: {
    height: '12px',
    width: '12px',
    margin: '0px 2px'
  }
});


class RUTransportsTableHeader extends React.Component {

  createSortHandler = property => event => {
    this.props.onRequestSort(event, property);
  };


  render() {
    const { order, orderBy, classes } = this.props;

    return (
      <TableRow className={classes.headerHeight} >
        {headerData.map(column => {
          return (
            <TableCell
              key={column.id}
              padding='none'
              sortDirection={orderBy === column.id ? order : false}
              className={column.sort ? classNames(classes.tblHeadT, classes.tblBorder, classes.textCenter, classes.cellPadding) :
                classNames(classes.tblHeadT, classes.tblBorder, classes.textCenter)}
            >
              {column.sort ?
                <TableSortLabel
                  className={classes.tblHeadT}
                  active={orderBy === column.id}
                  direction={order}
                  onClick={this.createSortHandler(column.id)}
                  classes={{ icon: classes.tblSort }}
                >
                  {column.label}
                </TableSortLabel>
                : column.label}
            </TableCell>
          );
        }, this)}
      </TableRow>
    );
  }
}

RUTransportsTableHeader.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired,
};

export default withStyles(styles)(RUTransportsTableHeader);


// WEBPACK FOOTER //
// ./src/components/UsedRentals/UsedRentalsTransport/UsedRentalsByLot/UsedRentalsTable/RUTransportsTableHeader.js